__webpack_require__.p = "/admin-two-vue-bulma-dashboard/";